import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/pensiunskService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "pensiunSKTableActive";
  defaultOrder = "employee_age";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.activeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "employee_nip",
      text: "NIP",
      className: "employee_nip", //
      sortable: true,
    },
    {
      key: "employee_name",
      text: "Nama",
      className: "employee_name", //
      sortable: true,
    },
    {
      key: "employee_position_name",
      text: "Posisi",
      className: "employee_position_name", //
      sortable: true,
    },
    {
      key: "employee_work_unit_name",
      text: "Unit Kerja",
      className: "employee_work_unit_name", //
      sortable: true,
    },
    {
      key: "emp_retired_sk_bkn_number",
      text: "No BKN",
      className: "emp_retired_sk_bkn_number", //
      sortable: true,
    },
    {
      key: "emp_retired_sk_bkn_date",
      text: "Tgl BKN",
      className: "emp_retired_sk_bkn_date", //
      sortable: true,
    },
    {
      key: "emp_retired_sk_number",
      text: "No SK Pensiun",
      className: "emp_retired_sk_number", //
      sortable: true,
    },
    {
      key: "emp_retired_sk_date_tmt", //employee_date_of_pension
      text: "Tgl Pensiun",
      className: "emp_retired_sk_date_tmt", // employee_date_of_pension
      sortable: true,
    },
    {
      key: "emp_retired_sk_date_tmt",
      text: "TMT Pensiun",
      className: "emp_retired_sk_date_tmt", //
      sortable: true,
    },
    {
      key: "retired_type_stop_name",
      text: "Jenis Pemberhentian",
      className: "retired_type_stop_name",
      sortable: true,
      cell: (record) => {
        var status = record.retired_type_stop_name;
        return (
          <span>
            <label className="badge rounded-pill bg-soft-success font-size-12">
              {status}
            </label>
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.emp_retired_sk_uuid;
        var status = record.emp_retired_sk_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.emp_retired_sk_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            {/* {accessRole("update") ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.emp_retired_sk_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-pen"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Perbaharui
                </Tooltip>
              </span>
            ) : null}
            {accessRole("delete") ? (
              <span>
                {parseInt(status) === 1 ? (
                  <span>
                    <button
                      className="btn btn-danger btn-sm"
                      id={"delete-" + thisId}
                      onClick={() => {
                        this.modal_confirm_status = 1;
                        this.modal_confirm_message =
                          "Apakah anda yakin akan menonaktifkan data ini ?";
                        this.setState({
                          inactiveUuid: record.emp_retired_sk_uuid,
                          confirm: true,
                        });
                      }}
                      style={{
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-trash-alt"></i>
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["delete" + thisId]}
                      target={"delete-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["delete" + thisId]: !this.state["delete" + thisId],
                        });
                      }}
                    >
                      Nonaktifkan
                    </Tooltip>
                  </span>
                ) : (
                  <span>
                    <button
                      className="btn btn-success btn-sm"
                      id={"delete-" + thisId}
                      onClick={() => {
                        this.modal_confirm_status = 0;
                        this.modal_confirm_message =
                          "Apakah anda yakin akan mengaktifkan data ini ?";
                        this.setState({
                          inactiveUuid: record.emp_retired_sk_uuid,
                          confirm: true,
                        });
                      }}
                      style={{
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-check"></i>
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["delete" + thisId]}
                      target={"delete-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["delete" + thisId]: !this.state["delete" + thisId],
                        });
                      }}
                    >
                      Aktifkan
                    </Tooltip>
                  </span>
                )}
              </span>
            ) : null} */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiunsk.html?detail&uuid=" + this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/pensiunsk.html?update&uuid=" + this.state.updateUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
